// Registrierung „Lesezeichen" für die Shell (Integrator hängt die Arrays in extras/index.tsx ein).
import type { ExtraMenuItem, ExtraRoute } from '../index';
import { BookmarkDialog } from './BookmarkDialog';
import { BookmarksPage } from './BookmarksPage';

export { BookmarkDialog } from './BookmarkDialog';
export { BookmarksPage } from './BookmarksPage';
export { BOOKMARK_FOLDERS_KEY, BOOKMARKS_KEY, bookmarkListKey } from './keys';

export const bookmarksRoutes: ExtraRoute[] = [{ path: '/bookmarks', element: BookmarksPage }];

export const bookmarksMenuItems: ExtraMenuItem[] = [
  { id: 'bookmark', label: 'Lesezeichen setzen', slot: 'messageMenu', component: BookmarkDialog, display: 'dialog' },
  { id: 'bookmarks', label: 'Lesezeichen', slot: 'userMenu', to: '/bookmarks' },
];
